import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GroupService } from '../../../../../../common/services/Group.service';
import { GroupConst } from './group.const';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import * as _ from 'lodash';

@Component({
  selector: 'settings-contact-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css'],
  providers: [GroupService, BsModalService],
})
export class GroupComponent extends BaseListComponent {
  @ViewChild('templateGroup') templateGroup: ElementRef;
  public modelFilter: any = {};
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private groupService: GroupService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = GroupConst.displayColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    request.target = 'end_user';
    const payload = await this.buildBasePayload(request, sort);
    this.groupService.list(payload).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.data = res.data.list;
          this.initPage(res.data.total);
        } else {
          this.throwError();
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async setUpModel(type) {
    this.typeModal = type;
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới nhóm khách hàng' : 'Cập nhật nhóm khách hàng',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên nhóm khách hàng',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
    ];
  }

  async search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      await this.loadData({ name: this.modelFilter.keyword.trim() });
    } else {
      await this.loadData();
    }
  }

  async openConfirmDelete() {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async submitDelete() {
    this.groupService._delete(this.delete_id).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Xóa thành công!');
          this.loadData();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async addGroup() {
    const payload = {
      target: 'end_user',
      name: this.model.name,
    };
    this.groupService.create(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async updateGroup() {
    const payload = {
      id: this.model.id,
      name: this.model.name,
    };
    this.groupService.update(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        await this.setUpModel('add');
        this.openModal(this.templateGroup, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
          }
        });
        await this.setUpModel('edit');
        this.openModal(this.templateGroup, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        this.delete_id = item.id;
        await this.openConfirmDelete();
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    if (this.typeModal === 'add') {
      await this.addGroup();
    } else if (this.typeModal === 'edit') {
      await this.updateGroup();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/group/group.component.ts